import { call, put, select, takeLatest, takeLeading } from "redux-saga/effects";
import { HistoryAPI } from "services/history";
import {
  getHistory,
  getHistorySuccess,
  getHistoryFailure,
  getHistoryDetail,
  getHistoryDetailSuccess,
  getHistoryDetailFailure,
  resendEmail,
  resendEmailSuccess,
  resendEmailFailure,
  fetchingHistoryDetail,
} from "redux/reducers/history-secondary";
import { HistorySelector } from "redux/selector/history-selector";
import find from "lodash/find";
import { message } from "antd";

function* getSecondaryHistorySaga({ payload }) {
  try {
    const response = yield call(HistoryAPI.Secondary.getHistory, payload);
    let histories = response.data.transactionHistoryList ?? [],
      total = response.data.total;
    yield put(getHistorySuccess({ histories, total }));
  } catch (error) {
    yield put(getHistoryFailure(error));
  }
}

function* getHistoryDetailSaga({ payload }) {
  try {
    const histories = yield select(HistorySelector.Secondary.histories);
    const history = find(histories, { transactionNo: payload.transactionNo });
    if (!history.fetched) {
      yield put(fetchingHistoryDetail());
      const response = yield call(HistoryAPI.Secondary.getHistoryDetail, payload);
      let historyDetail = response.data.transactionDetail ?? {};
      yield put(getHistoryDetailSuccess(historyDetail));
    }
  } catch (error) {
    yield put(getHistoryDetailFailure(error));
  }
}

function* resendEmailSaga({ payload }) {
  try {
    yield call(HistoryAPI.Secondary.resendEmail, payload);
    message.info("ส่งอีเมลเรียบร้อย");
    yield put(resendEmailSuccess(payload));
  } catch (error) {
    yield put(resendEmailFailure(error));
  }
}

const saga = [
  takeLeading(getHistory.type, getSecondaryHistorySaga),
  takeLatest(getHistoryDetail.type, getHistoryDetailSaga),
  takeLatest(resendEmail.type, resendEmailSaga),
];

export default saga;
